import { useCallback, useState } from 'react';

const useLoadingTracker = () => {
  const [loadingCount, setLoadingCount] = useState(0);

  const startLoading = useCallback(() => setLoadingCount((c) => c + 1), []);
  const endLoading = useCallback(() => setLoadingCount((c) => c - 1), []);

  return {
    isAnyLoading: loadingCount > 0,
    startLoading,
    endLoading,
  };
};

export default useLoadingTracker;
